import '../styles/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            {/* Fila superior */}
            <div className="footer-top">
                <p>© 2025-2026 SIGBI-712. Todos los derechos reservados.</p>
            </div>

            {/* Fila inferior */}
            <div className="footer-bottom">
                <div className="footer-column">
                    <h4>Ubícanos</h4>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1882.6624913039977!2d-99.11986675269338!3d19.31169933293223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce019414f85a07%3A0x2c75e92443883995!2sCalz.%20de%20las%20Bombas%20421%2C%20Coapa%2C%20Parque%20Alameda%20del%20Sur%2C%20Coyoac%C3%A1n%2C%2004800%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX!5e0!3m2!1ses!2smx!4v1775697504885!5m2!1ses!2smx"
                        width="100%"
                        height="200"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Mapa Ubicación"
                    ></iframe>
                </div>

                <div className="footer-column">
                    <h4>Contáctanos</h4>
                    <p>Tel: 55 57239300 ext: 33024</p>
                    <p>servicios_informaticos_712@sict.gob.mx</p>
                </div>

                <div className="footer-column">
                    <h4>Sitio y Redes</h4>
                    <p>
                        <a
                            href="https://www.gob.mx/sict/acciones-y-programas/recursos-materiales-sct"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Gob.mx SICT
                        </a>
                    </p>
                    <p>
                        <a
                            href="https://www.instagram.com/sict_mx/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Instagram SICT
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;